import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ArrayConstants } from '../../../constants/arrays';
@Component({
  selector: 'app-gender-filter',
  templateUrl: './gender-filter.component.html'
})
export class GenderFilterComponent implements OnInit {
  @Input() dropdownFilterGender;
  @Output() genderFilterOutput = new EventEmitter();
  public genderList = ArrayConstants.genderArray;
  constructor() { }

  ngOnInit() {
  }
  /* fn trigeered when selecting any value in dropdown */
  public clearFilter() {
    this.dropdownFilterGender.value = 'ALL';
    this.dropdownFilterGender.key = '';
    this.genderFilterOutput.next('clear');
  }
  /* fn trigeered when selecting any value in dropdown */
  public dropdownSelect(item) {
    this.dropdownFilterGender.value = item.value;
    this.dropdownFilterGender.key = item.key;
  }
  /* hide the dropdown clicking outside */
  public dropdownClickOutside(event) {
    this.dropdownFilterGender.show = false;
  }
}
